import Heading from "components/Heading";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button, Col, Container, Row, Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import { errorHandler } from "utils/Api";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import LoadingTBody from "components/LoadingTBody";
import { showAlert } from "utils/Alert";
import DeleteModal from "components/DeleteModal";
import { getPrices } from "api/PriceApi";

const Prices = props => {
  let navigate = useNavigate();
  const [pricesList, setPricesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [toDeletePrice, setToDeletePrice] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetchPrices();
  }, [pricesList.length]);

  const fetchPrices = () => {
    getPrices().then((prices) => {
      setPricesList(prices);
    }).catch((e) => errorHandler(e, "Fetch Prices list error"))
      .finally(() => {
        setIsLoading(false);
      });
  }

  const renderList = () => {
    return pricesList.map((price) => {
      return (
        <tr key={price.id}>
          <td>
            {price.secuencia}
          </td>
          <td>
            {price.name}
          </td>
          <td>
            {price.isAllInclusive ? "Si" : "No"}
          </td>
          <td>
            {price.isPublic ? "Si" : "No"}
          </td>
          <td>
            {price.isDefault ? "Si" : "No"}
          </td>
          <td>
            {price.isActive ? "Si" : "No"}
          </td>
          <td>
            {rowActions(price)}
          </td>
        </tr>
      );
    });
  }

  const deletePrice = (price) => {
    setIsLoading(true);
    deletePrice(price)
      .then(async (r) => {
        showAlert("success", `El Precio "#${price.name}" fue eliminado correctamente`);
        toogleModal();
      }).catch(e => {
        errorHandler(e);
        showAlert("danger", `No fue posible eliminar el Precio "#${price.name}" `);
      })
      .finally(() => fetchPrices());
  }

  const showDeleteConfirm = (price) => {
    setToDeletePrice(price);
    setIsModalOpen(true);
  }

  const toogleModal = (e) => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setToDeletePrice({});
    }
  }

  const rowActions = (price) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/price/edit/${price.id}`) }}>
            Editar Precio
          </DropdownItem>
          <DropdownItem onClick={(e) => showDeleteConfirm(price)}>
            Eliminar Precio
          </DropdownItem>

        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  return (
    <>
      <Heading headingLevel="h2" className="pt-4" label="Tipos de Precios" sticky >
        <Col sm={2}>
          <Button
            className="float-end"
            color="success"
            onClick={(e) => navigate("/admin/price/add")}
          > Agregar</Button>
        </Col>
      </Heading>
      <Container>
        <Row>
          <Col>
            <Table hover>
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Tipo
                  </th>
                  <th>
                    Todo Includo
                  </th>
                  <th>
                    Precio Al Publico
                  </th>
                  <th>
                    Precio Por Defecto
                  </th>
                  <th>
                    Activo
                  </th>
                  <th width="2%"></th>
                </tr>
              </thead>
              <LoadingTBody isLoading={isLoading}>
                {renderList()}
              </LoadingTBody>
            </Table>
            {toDeletePrice && toDeletePrice.id && (
              <DeleteModal
                title="Eliminar Precio"
                toogle={toogleModal}
                isOpen={isModalOpen}
                onDelete={() => { deletePrice(toDeletePrice) }}>
                Esta seguro que desea eliminar el Tipo de Precio #{toDeletePrice.name}?
              </DeleteModal>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Prices;
